<template>
  <div>
    <v-subheader class="title-setting">Configuración de Gastos</v-subheader>
    <v-form v-on:submit.prevent="save">
      <div class="col-md-12">
        <!-- Sección: Órdenes de Compra -->
        <div class="col-md-12 mt-4">
          <p class="mb-2 font-weight-bold">Órdenes de Compra</p>
          
          <v-checkbox
            v-model="mainItem.require_purchase_order_for_spent"
            label="Requerir orden de compra para crear un comprobante de gasto"
            hint="Si está activado, será obligatorio crear una orden de compra aprobada antes de poder crear un comprobante de gasto. El botón de crear comprobante directo será deshabilitado."
            persistent-hint
          ></v-checkbox>

          <v-checkbox
            v-model="mainItem.authorize_purchase_order"
            label="Autorizar órdenes de compra"
            hint="Si está activado, las órdenes de compra requerirán autorización antes de poder ser utilizadas."
            persistent-hint
            class="mt-3"
          ></v-checkbox>
        </div>

        <v-divider class="my-6"></v-divider>

        <!-- Sección: Pagos -->
        <div class="col-md-12">
          <p class="mb-2 font-weight-bold">Pagos</p>
          
          <v-checkbox
            v-model="mainItem.require_payment_order_for_payment"
            label="Requerir solicitud de pago para crear un pago"
            hint="Si está activado, será obligatorio crear una solicitud de pago antes de poder crear un pago. El botón de crear pago directo será deshabilitado."
            persistent-hint
          ></v-checkbox>
        </div>

        <v-divider class="my-6"></v-divider>

        <!-- Sección: Firma para certificados de retenciones -->
        <div class="col-md-12">
          <p class="mb-2 font-weight-bold">Firma para certificados de retenciones</p>
          <p class="caption mb-4">Configure la firma que se incluirá en los certificados de retenciones</p>

          <div class="col-md-6">
            <img v-if="mainItem.signature_image_url != null && mainItem.signature_image_url.length > 0" :src="mainItem.signature_image_url" style="object-fit: cover; max-width: 300px; max-height: 150px; border: 1px solid #ccc; padding: 8px;" />
            <v-avatar size="130px" v-if="mainItem.signature_image_url == null || mainItem.signature_image_url == ''">
              <img :src="require('@/assets/images/no-photo.png')" style="object-fit: cover" />
            </v-avatar>
          </div>

          <div class="col-md-12 mt-3">
            <p class="caption">Tamaño recomendado 300x100px (formato: PNG con fondo transparente)</p>
            <v-btn @click="uploadSignatureImage()" color="primary" small> 
              <v-icon small left>mdi-image-plus</v-icon>
              Adjuntar imagen de firma
            </v-btn>
            <v-file-input 
              v-show="false" 
              label="Firma" 
              name="signature_image_upload" 
              ref="signature_image_ref" 
              v-model="mainItem.signature_image_upload" 
              accept="image/*"
              @change="setSignatureImage()"
            ></v-file-input>
          </div>

          <div class="col-md-12 mt-4">
            <v-textarea
              filled
              data-vv-as="Observación de firma"
              label="Observación de firma"
              name="signature_observation"
              v-model="mainItem.signature_observation"
              hint="Texto que acompañará la firma en los certificados (ej: nombre y cargo del firmante)"
              persistent-hint
              rows="3"
            ></v-textarea>
            <span class="red--text">{{ errors.first("signature_observation") }}</span>
          </div>
        </div>

        <div class="col-md-12 mt-4 text-right">
          <v-btn color="green darken-1" text :loading="loading" type="submit"> Guardar </v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    mainItem: Object,
    createItem: Function,
    loading: Boolean,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    uploadSignatureImage() {
      this.$refs.signature_image_ref.$refs.input.click();
    },
    setSignatureImage() {
      if (this.mainItem.signature_image_upload) {
        this.mainItem.signature_image_url = URL.createObjectURL(this.mainItem.signature_image_upload);
      }
    },
    save(e) {
      this.$emit("createItem", e);
    },
  },
};
</script>

<style scoped>
.title-setting {
  font-size: 18px;
  font-weight: 500;
}
</style>
